import { League } from "./League";
import { Cup } from "./Cup";
import { Ladder } from "./Ladder";
import { Eas2 } from "./Eas2";
import { Swiss } from "./Swiss";
import { Premiership } from "./Premiership";
import { FFA } from "./FFA";

export class LeagueFactory {
    public static getLeagueByType(leagueData): League {
        switch (leagueData.type) {
            case "cup":
                return new Cup(leagueData);
            case "ladder":
                return new Ladder(leagueData);
            case "premiership":
                return new Premiership(leagueData);
            case "a-series":
                return new Eas2(leagueData);
            case "esl-series":
                return new Eas2(leagueData);
            case "swiss":
                return new Swiss(leagueData);
            case "ffa":
                return new FFA(leagueData);
            default:
                return new League(leagueData);
        }
    }
}
